const getters = {
    sidebar: state => state.app.sidebar,
    language: state => state.app.language,
    size: state => state.app.size,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    logo: state => state.user.logo,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    permission_routes: state => state.permission.routes,
    addRoutes: state => state.permission.addRoutes,
    buttons: state => state.permission.buttons,
    ptzControl: state => state.permission.ptzControl,
    errorLogs: state => state.errorLog.logs,
    getFlightInspection: state => state.flightInspection,
    // 公制转英制（m => ft）
    metricToBritish: (state) => (value) => {
        if (state.metricAndBritishSystem === 2) {
            return value * 3.2808;
        } else {
            return value * 1;
        }
    },

    // 英制转公制（ft => m）
    britishToMetric: (state) => (value) => {
        if (state.metricAndBritishSystem === 2) {
            return (value * 1) / 3.2808;
        } else {
            return value * 1;
        }
    },

    // 公制转英制速度（m/s => mph）
    speedMetricToBritish: (state) => (value) => {
        if (state.metricAndBritishSystem === 2) {
            const kph = (value * 3600) / 1000; // km/h或者kph
            const mph = kph * 0.6213712;
            return mph; // mi/h或者mph
        } else {
            return value * 1;
        }
    },

    // 英制转公制速度（mph => m/s）
    speedBritishToMetric: (state) => (value) => {
        if (state.metricAndBritishSystem === 2) {
            const kph = ((value * 1 / 0.6213712) * 1000) / 3600; // km/h或者kph
            return kph;
        } else {
            return value * 1;
        }
    },
}
export default getters
